import { SyntheticEvent } from 'react';
import classNames from 'classnames';

import { ReactComponent as ExpandedMinus } from 'public/assets/icons/ExpandedMinus.svg';
import { ReactComponent as CollapsedPlus } from 'public/assets/icons/CollapsedPlus.svg';

import styles from './styles.module.scss';

interface IProps {
  title: string,
  description: string,
  handleClick: (event: SyntheticEvent<HTMLDivElement>) => void,
  isActive?: boolean,
}

const ListItem = ({
  title,
  description,
  isActive,
  handleClick,
}: IProps) => (
  <div className={classNames(styles.container, { [styles.active]: isActive })}>
    <div
      className={styles.header}
      onClick={handleClick}
      role="button"
      tabIndex={-1}
      data-id={title}
    >
      { /* eslint-disable-next-line react/no-danger */ }
      <div dangerouslySetInnerHTML={{ __html: title }} />
      {isActive
        ? <ExpandedMinus />
        : <CollapsedPlus />}
    </div>
    <div className={styles.description}>
      { /* eslint-disable-next-line react/no-danger */ }
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  </div>
);

export default ListItem;
